import { LinearProgress } from '@mui/material';

const Loading = () => {
    return <LinearProgress />;
};

export default Loading;
